import { CategoryRestrictions, DisplayCategoryFragment } from '@ocx/graphql';

/**
 * DisplayCategories sorting by "rank" field.
 * If DisplayCategories has the same "rank" value — they are sorted by "name".
 */
export const sortDisplayCategoriesByNameAndRank = (a: DisplayCategoryFragment, b: DisplayCategoryFragment) => {
  if (a.rank === b.rank) {
    return a.name.localeCompare(b.name);
  }
  return a.rank - b.rank;
};

/**
 * Filter restricted categories (client-side until API supports it).
 * `membershipRestrictionVerification` is `fuelAndConvenienceProfile.restrictionVerification` from membership (pass from caller to avoid coupling this module to `@ocx/data-membership`).
 */
export const filterCategoriesRestriction = (
  categories: DisplayCategoryFragment[],
  membershipRestrictionVerification?: CategoryRestrictions | null,
) => {
  return categories.filter((category) => {
    const categoryRestriction = category.categoryRestrictions;

    if (!membershipRestrictionVerification) {
      // Show only unrestricted categories (null by default)
      return !categoryRestriction;
    }

    if (membershipRestrictionVerification === CategoryRestrictions.Age) {
      // Show categories that are either unrestricted, as well as having 'AGE' restriction
      return categoryRestriction === CategoryRestrictions.Age || !categoryRestriction;
    }

    // A member that is EAIV verified can see ALL display categories
    return membershipRestrictionVerification === CategoryRestrictions.Eaiv;
  });
};
